import { ChangeDetectorRef, Component, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DTFHomepageService } from '../../../../components/dtfhomepage/dtfhomepage.service';
import { AuthorizationService } from '../../../../components/authorization/authorization.service';
import { WindowRef } from '../../../../utils/window';
import { TranslateService } from '@ngx-translate/core';
import { Banner } from '../../../../shared/models/banner';
import { TranslateUtil } from '../../../../utils/translate-util';
import { APP_CONSTANTS } from '../../../../utils/app-constants';
import { AccoutDetailsResponse } from '../../../../shared/models/accountDetailsResponse';

import { MatSort, MatSortModule } from '@angular/material/sort';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { AssetListResponse } from '../../../../shared/models/assetListResponse';
import { PayoffResponseBeanList } from '../../../../shared/payoffResponseBeanList';
import { ContractNumberRequest } from '../../../../shared/models/contractNumberResponse';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSelectModule } from '@angular/material/select';
import { SharedTranslateModule } from '../../../../utils/sharedTranslateModule';
import { MatPaginator } from '@angular/material/paginator';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { PaymentHistoryResponse } from '../../../../shared/models/paymenthistoryResponse';
import { MatIconModule } from '@angular/material/icon';
import { DTFPayoffService } from '../../../../components/payoff/payoff.service';
import jsPDF from 'jspdf';
import { DatePipe, formatDate } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import { PaymenthistoryRequest } from '../../../../shared/models/paymenthistoryRequest';
import { provideNativeDateAdapter } from '@angular/material/core';
import { SessionTimeoutComponent } from '../../../../../../src/app/components/sessionTimeout/sessionTimeout.component';

enum CheckeBill {
  Enroll_ebill,
  Terminate_ebill,
  NONE
};

interface Payments {
  value: string;
  viewValue: string;
}






export enum ToggleEnum { //used for mat toggle
  Option0,
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6,
  Option7,
  Option8,
  Option9,
}

@Component({
    selector: 'div.dtf-paymenthistory',
    templateUrl: './paymenthistory.component.html',
    providers: [provideNativeDateAdapter()],
    imports: [SharedTranslateModule,
        MatPaginator, MatSort, MatTableModule, MatInputModule, MatCheckboxModule, MatFormFieldModule,SessionTimeoutComponent,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatDatepickerModule, MatSortModule, MatIconModule
    ],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})



export class PaymenthistoryComponent implements OnInit {
  title = 'Content Section of the Page';
  private _window: WindowRef;
  router: Router;
  path = '';
  enrollFlagFromDB: string;
  UIpages = ['insurance', 'account', 'amortization', 'documentcenter', 'invoice', 'manageYourProfile'];
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  isCanadaPortal = false;
  baseUrl = '';
  usUrl: string;
  caUrl: string;
  olpUrl :string;
  azURL: string;
  agentview: string;
  agentId: string;
  userDcsAccount: string;
  emailAddress: string;
  customerName: string;
  bodyLoaded = false;
  dbLoaded = false;
  tableLoaded=false;
  openLoginModal = false;
  serviceErrorOccurred = false;
  serviceErrorDesc = '';
  userId = '';
  dbData: any;
  public alerts: Banner;
  toggleOpen: any;
  recAccCount = '';
  totalDue = '';
  emailOffers = true;
  isReset = false;
  userExist = false;
  marked = false;
  make_payment = false;
  principal_payment = false;
  trans_history = false;
  invoice_payment = false;
  invoice_history= false;
  trk_recurring=false;
  trk_recurring_history=false;
  bank_profile=false;
  help=false;
  SelectEnrollForm = false;
  SelectTerminateForm = false;
  disabledFlag =false;
  dataLoaded=true;
  olpredirecturl: any = null;
  CANCEL = '';
  //used for mat-toggle
  toggleEnum = ToggleEnum;
  selectedState = ToggleEnum.Option0;

  filterActive = false;
  filter = false;
  rowCount = 0;
  value = '';
  EncryptionRequest: any ={}
  isFrench = false;
  language = '';
  token: string;
  accountDetailsRes: AccoutDetailsResponse[];
  paymentHistoryRes: PaymentHistoryResponse[];
  invalid = false;
  //selectedState = 0;
  ciamId = sessionStorage.getItem('loginID');
  getMultiPayoffRequest: any ={};
  thirdPartyNumber = sessionStorage.getItem('thirdPartyNumber');
  terminationDate ='';
  brandId: string;
  name: string;
  step1 = true;
  step2 = false;
  baseRedirect = '';
  currentDate: Date;
  selectedPayments: Payments[] = [
    {value: 'make payments', viewValue: 'Make a Payment'},
    {value: 'principal payments', viewValue: 'Principal Payment'},
    {value: 'recurring payments', viewValue: 'Recurring Payment'},
    {value: 'statement payments', viewValue: 'Statement Payment'},
    {value: 'payment history', viewValue: 'Payment History'},
    {value: 'manage profile', viewValue: 'Manage Bank Profile'},
    
  ];
  selectedPayment: string | null = null;
  contractNumberList: ContractNumberRequest[];
  startDateMap: { [contractNum: string]: Date } = {};
  endDateMap: { [contractNum: string]: Date } = {};
  selectedPaymentList: PaymenthistoryRequest[];
  selectedPaymentHistory: PaymenthistoryRequest;
  dateerror = false;
  accounterror = false;
  // Current =  true;
  // DTPAY = false;
  
 
  
  initPaymentTransactionColumns: any[] = [
    {
      name: 'accountNumber',
      display: 'Account Number',
      displayFR: 'Numéro de compte',
      dispFormat: ''
    },
    {
      name: 'amountamount',
      display: 'Amount',
      displayFR: 'Montant',
      dispFormat: 'amount'
    },
    {
      name: 'reference',
      display: 'Transaction ID',
      displayFR: 'Identification de transaction',
      dispFormat: 'transactionid'
    },
    {
      name: 'dateReceived',
      display: 'Transaction Date',
      displayFR: 'Date de transaction',
      dispFormat: 'transactiondate'
    },
   
    {
      name: 'paymentMethod',
      display: 'Payment Method',
      displayFR: 'Mode de paiement',
      dispFormat: 'paymentmethod'
    },
  ];
  displayedColumnsPaymentTransaction: any[] = this.initPaymentTransactionColumns.map(col => col.name);

  initPaymentTransactionColumnsStep1: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'contractNum',
      display: 'Account Number',
      displayFR: 'Numéro de compte',
      dispFormat: 'acct'
    },
    {
      name: 'startDate',
      display: 'Start Date',
      displayFR: 'Date de commencement',
      dispFormat: 'startdate'
    },
    {
      name: 'endDate',
      display: 'End Date',
      displayFR: 'Date de terminaison',
      dispFormat: 'enddate'
    }
  ];
  displayedColumnsPaymentTransactionStep1: any[] = this.initPaymentTransactionColumnsStep1.map(col => col.name);

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  selection = new SelectionModel<AccoutDetailsResponse>(true, []);
  dataSource: MatTableDataSource<AccoutDetailsResponse>;
  dataSource1:MatTableDataSource<PaymentHistoryResponse>;
  pipe: DatePipe;


  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil, private sanitizer: DomSanitizer, private service: DTFPayoffService, private cdr: ChangeDetectorRef
  ) {
    this.router = router;
    this._window = window;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.olpUrl = (this._window.nativeWindow as any).mbfs.olpUrl;
    this.accountDetailsRes =[];
    this.paymentHistoryRes = [];
    this.selectedPaymentList = [];
    dataSource: MatTableDataSource<AccoutDetailsResponse>;
    dataSource1:MatTableDataSource<PaymentHistoryResponse>;

  }

  ngAfterViewInit() {
  }

  ngOnInit() {
    this.langInit();
    this.agentview = sessionStorage.getItem('agentview');
    this.agentId = sessionStorage.getItem('agentID');
    this.customerName = sessionStorage.getItem('customerName');
    this.emailAddress = sessionStorage.getItem('emailAddress');
    const language = (window as any).mbfs.language;
    this.language= language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;
    this.token = sessionStorage.getItem('ciamToken');
    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
      this.currentCountry = val;
      this.cdr.detectChanges();
    });
    const dashBoardRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token
    };

    this.getDashBoardDetails(dashBoardRequest);
    this.getAccountDetailsListByUserId();
    //this.getAlerts();
    this.isFrench = ('fr-CA' === this.language) ? true : false; 
    this.accounts();
  }

   langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;

    // Checks if what language user is to redirect to correct href in link nav
    if (this.language === 'en-CA') {
        this.baseRedirect = this.usUrl + '/ca/en/';
    } else if (this.language === 'fr-CA') {
        this.baseRedirect = this.usUrl + '/ca/fr/';
    } else {
        this.baseRedirect = this.usUrl;
    }
    this.isFrench = ('fr-CA' === this.language) ? true : false; //checks if language is french or english for Canada
  }


  onChangeButton($event) { //Used for mat-toggle conditions to filter DB
    this.selectedState = $event.value;
   
    if (this.selectedState === 1) {
      this.azURL =  this.usUrl + '/home/principalpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 2) {
      this.azURL =  this.usUrl + '/home/paymenthistory';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 3) {
      this.azURL =  this.usUrl + '/home/statementpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 4) {
      this.azURL =  this.usUrl + '/home/bankprofile';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 6) {
      this.azURL =  this.usUrl + '/home/recurringpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 7) {
      this.azURL =  this.usUrl + '/home/onlinepayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 8) {
      this.azURL =  this.usUrl + '/home/help';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    } 
  }

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }

    
  }

 
  applyFilterAcc(input: string) {
    this.dataSource1.filterPredicate = (data: PaymentHistoryResponse, f: string) => {
      // Remove whitespace and convert the filter string to lowercase
      f = f.trim().toLowerCase();
  
      // Check if filter string matches either reference or amount field
      return !f || 
             data.accountNumber.toLowerCase().includes(f) || 
             data.amountamount.toString().toLowerCase().includes(f);
    };
  
    // Set the filter for the dataSource and update row count
    this.dataSource1.filter = input.trim().toLowerCase();
    this.rowCount = this.dataSource1.filteredData.length;
  }

  applyFilterAccPr(input: string) {
    this.dataSource.filterPredicate = (data: AccoutDetailsResponse, f: string) => {
      // Remove whitespace and convert the filter string to lowercase
      f = f.trim().toLowerCase();
  
      // Check if filter string matches either reference or amount field
      return !f || 
             data.contractNum.toLowerCase().includes(f);
    };
  
    // Set the filter for the dataSource and update row count
    this.dataSource.filter = input.trim().toLowerCase();
    this.rowCount = this.dataSource.filteredData.length;
  }
  
  applyFilterDate(inputDate: string) {
    if (!inputDate) {
      this.dataSource1.filter = '';  
      this.rowCount = this.dataSource1.data.length;  
    } else {
      // Format the input date to 'yyyy-MM-dd'
      const formattedInputDate = formatDate(new Date(inputDate), 'yyyy-MM-dd', 'en-US');
      this.dataSource1.filterPredicate = (data: PaymentHistoryResponse, filter: string) => {
        if (!filter) return true;  
        const formattedDateReceived = formatDate(new Date(data.dateReceived), 'yyyy-MM-dd', 'en-US');
        return formattedDateReceived === formattedInputDate;
      };
     
      this.dataSource1.filter = formattedInputDate;
      this.rowCount = this.dataSource1.filteredData.length;
    } 
    if (this.dataSource1.paginator) {
      this.dataSource1.paginator.firstPage();
    }
  }
  

  applyFilterpaymentmethod(input2: string) {
    this.dataSource1.filterPredicate = (data: PaymentHistoryResponse, f: string) =>
      !f ||
      data.paymentMethod.toLowerCase().includes(f) 
    input2 = input2.trim(); // Remove whitespace
    input2 = input2.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource1.filter = input2;
    this.rowCount = this.dataSource1.filteredData.length;
  }

  BacktoDashBoard(){
    if(this.langFlag === 'fr-CA'){
      this.azURL = this.usUrl + '/ca/fr/home/dashboard';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
      }, 1000);
    }else if(this.langFlag === 'en-CA'){
    this.azURL = this.usUrl + '/ca/en/home/dashboard';
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
   }else{
    this.azURL = this.usUrl + '/home/dashboard';
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
   }
  }

  
  // DtpayToggle() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //     for (var i = 0; i < res.length; i++) {
  //       if (res[i].btnUrl === "DTPAY") {
  //         this.Current = false;
  //         this.DTPAY = true;
  //       }
  //     }
  //   });
  // }


  accounts(){
    this.tableLoaded = false;
    this.cdr.detectChanges();
    const accountDetailsRequest = {
      ciamId : this.ciamId ,
      ciamAZCode :this.token
    };
    this.auth.getAccountDetailsListByUserId(accountDetailsRequest).subscribe(res => {
      this.accountDetailsRes = [];
      this.accountDetailsRes = res.accountdetailsList;
      this.accountDetailsRes.forEach(contract => {
        // Get today's date and subtract 6 months
        const today = new Date();
        today.setMonth(today.getMonth() - 6);
      
        // Set the start date to 6 months ago for each contract
        this.startDateMap[contract.contractNum] = today;
      
        this.endDateMap[contract.contractNum] = new Date();})
      this.dataSource = new MatTableDataSource(this.accountDetailsRes);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.tableLoaded = true;
        this.cdr.detectChanges();
    }, () => {
      this.tableLoaded = true;
      this.cdr.detectChanges();
    });
  }


  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //     for (var i = 0; i < res.length; i++) {
  //       if (this.currentCountry === 'CA') {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerName.indexOf((this.langFlag)) !== -1 &&
  //           res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //       else {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     }
  //   });
  // }
  
  formValidationClasses = {
    'mbfs-error': true,
  };

  getDashBoardDetails(dashBoardRequest) {
      this.auth.getDashBoardDetails(dashBoardRequest).subscribe(res => {
      this.recAccCount = res.recAccCount;
      this.totalDue = res.totalDue;
      if (this.totalDue.includes("-")) {
        this.totalDue = "0.00";
      }
      this.cdr.detectChanges();
    });
  }

  closeCIAMModal(e: Event) {
    this.openLoginModal = false;
    this.userExist = false;
    this.isReset = false;
    this.serviceErrorOccurred = false;
  }

  getAccountDetailsListByUserId() {
    const accountDetailsRequest = {
      ciamId : this.ciamId ,
      ciamAZCode :this.token
    };
    this.auth.getAccountDetailsListByUserId(accountDetailsRequest).subscribe(res => {
      this.accountDetailsRes = res.accountdetailsList;
      this.userDcsAccount = this.accountDetailsRes[0].contractNum; //used for userDcsAccount
      this.cdr.detectChanges();
      this.encryptCTR("make_payment");
    });
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensure two digits
    const day = date.getDate().toString().padStart(2, '0'); // Ensure two digits
    return `${year}-${month}-${day}`;
  }


  getlistAllPaymentsForSchedule(){
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
     this.cdr.detectChanges();

    if(numSelected < 1){
      this.invalid = true;
      this.accounterror = true;
      this.dateerror = false;
    }
    
    const selectedRows = this.selection.selected;
    
    
    this.selection.selected.forEach(row => {
      const contract = row.contractNum;
      const startDate = this.formatDate(this.startDateMap[row.contractNum]);
      const endDate = this.formatDate(this.endDateMap[row.contractNum]);

      if (startDate && endDate) {
        if (new Date(startDate) > new Date(endDate)) {
          // Start date is after end date
          this.invalid = true;
          this.accounterror = false;
          this.dateerror = true;
        } else if (new Date(endDate) < new Date(startDate)) {
          // End date is before start date
          this.invalid = true;
          this.accounterror = false;
          this.dateerror = true;
        }else{
          this.invalid = false;
          this.accounterror = false;
          this.dateerror = false;
        }
      }

      this.selectedPaymentHistory = new PaymenthistoryRequest();
      this.selectedPaymentHistory.agreementNumber = contract.slice(0, -3);
      this.selectedPaymentHistory.scheduleNumber = 1;
      this.selectedPaymentHistory.startDate = startDate;
      this.selectedPaymentHistory.endDate = endDate;
      this.selectedPaymentList.push(this.selectedPaymentHistory);
      });
      
      const requestData =  this.selectedPaymentList; 


      if(!this.invalid){
      this.step1 = false;
      this.step2 = true;
      this.tableLoaded = false;
      this.auth.getlistAllPaymentsForSchedule(requestData).subscribe(res=> {
        this.paymentHistoryRes = res;
        for (var i = 0; i < this.paymentHistoryRes.length; i++) {
          this.paymentHistoryRes[i].accountNumber = this.paymentHistoryRes[i].accountNumber + "001";
        }
        this.cdr.detectChanges();
        this.dataSource1 = new MatTableDataSource(this.paymentHistoryRes);
          this.dataSource1.paginator = this.paginator;
          this.dataSource1.sort = this.sort;
          this.tableLoaded = true;
            this.cdr.detectChanges();
        }, () => {
          this.tableLoaded = true;
          this.cdr.detectChanges();
        });
    }
  }
  
  back(){
    window.location.reload();
    this.step1 = true;
    this.step2 = false;
  }



  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;    
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
    this.selection.clear() : this.dataSource.data.forEach(row => this.selection.select(row));
  }

  encryptCTR(pageredirect){
    this.tableLoaded = false;
    // var userDcsAccount = "1x85zd1mm2j7o,aazsgw7d4yvh";
    // var page = "make_payment";
    // var email="-187285s28mk02,-9z3l3ab3ckdy,-tif2j9bahsoc,-z2e8o5shibca,-88yzg6hxzaf5";
    // var userid = "-1bf1hp4u0ci8s,-1jk7md3lp8776,-al7jpib067tr";
    // var sessionId ="-1786lcq8mwgas,vy3nmdjts5h3,-1u9vx3m63al2c,a8mm96xc7s1j,ofv0hueokk2"
    // var cCANNumber ="-t77ci0d88wua,eqg6gj3rr3ep";
    // var agentView = "false";
    // var custName ="-va6bpefc2zu8,-12dd9oq7efwgu,-al7jpib067tr&userId=1p6yx2n7xsznn,-742ql3z0iwe3,-al7jpib067tr";
    // var colorCode ="&colorCode=TRK";


   
    var userDcsAccount = this.userDcsAccount;
    var page = '?page='+ pageredirect;
    var email=this.emailAddress;
    var userid = this.ciamId;
    var sessionId =this.token;
    var cCANNumber =this.thirdPartyNumber;
    var agentView = this.agentview;
    var custName =this.customerName;
    var colorCode ="&colorCode=TRK";
    var selectedAccount = "&selectedAccount=All"

    var tempnames = ["&userDcsAccount=","&email=", "&userId=", "&cCANNumber=","&custName="]
    var tempvalues =[userDcsAccount, email,userid, cCANNumber,custName];
   
    var payoffcheck = sessionStorage.getItem('page');
    if (payoffcheck === 'payoff_quote' ){
      var page = '?page='+ payoffcheck;
      var amount = sessionStorage.getItem('amount');
      var quoteNumber = sessionStorage.getItem('quoteNumber');
      var selectedAcct  = sessionStorage.getItem('selectedAcct');

      var payoffnames = ["&amount=","&selectedAcct=", "&quoteNumber="];
      var payoffvalues = [amount, selectedAcct, quoteNumber];
      tempnames.push(payoffnames[0],payoffnames[1],payoffnames[2]);
      tempvalues.push(payoffvalues[0],payoffvalues[1],payoffvalues[2]);

      sessionStorage.removeItem('page'); //prevent payoff from loading again
      sessionStorage.removeItem('amount'); //prevent payoff from loading again
      sessionStorage.removeItem('selectedAcct'); //prevent payoff from loading again
      sessionStorage.removeItem('quoteNumber'); //prevent payoff from loading again

    }
    this.EncryptionRequest = {};
    this.EncryptionRequest = {
     values: tempvalues
   };
    this.auth.encryptCTR(this.EncryptionRequest).subscribe(res => {
      var tempurl = this.olpUrl + page  + selectedAccount +colorCode + "&sessionId=" + sessionId + "&agentView=" +agentView; 
      // var originalurl = this.olpUrl + page + selectedAccount +colorCode + "&sessionId=" + sessionId +"&agentView=" +agentView; 
      for(var i =0; i < res.values.length; i++){
        var temp = tempnames[i] + res.values[i].toString(); 
        // var tempprigin = tempnames[i] + tempvalues[i].toString(); 
        tempurl  += temp;
        // originalurl += tempprigin;
      }
      // var tempurl = this.olpUrl  + userDcsAccount + page + email + userid + "&sessionId=" + sessionId + cCANNumber + "&agentView=" +agentView  + custName + colorCode;
      this.olpredirecturl = this.sanitizer.bypassSecurityTrustResourceUrl(tempurl);
      this.make_payment = true;
      this.cdr.detectChanges();
      setTimeout(() => {
        this.tableLoaded = true;
        this.cdr.detectChanges();
      }, 500); //2s
      }, () => {
        this.tableLoaded = true;
        this.cdr.detectChanges();
      });
    
  }

 
}